import Pagination from "../../Pieces/Pagination";
export default {
  name: 'AllLogs',
  components: {
    Pagination: Pagination
  },
  data: function data() {
    return {
      logs: [],
      loading: false,
      pagination: {
        current_page: 1,
        per_page: 10,
        total: 0
      }
    };
  },
  methods: {
    fetch: function fetch() {
      var _this = this;
      this.loading = true;
      this.$get('reports/logs', {
        per_page: this.pagination.per_page,
        page: this.pagination.current_page,
        "with": ['trigger', 'actions']
      }).then(function (response) {
        _this.logs = response.logs.data;
        _this.pagination.total = response.logs.total;
      })["catch"](function (errors) {
        _this.$handleError(errors);
      }).always(function () {
        _this.loading = false;
      });
    }
  },
  mounted: function mounted() {
    this.fetch();
  }
};